import { get, writable } from 'svelte/store';
import { navigate } from '../../app.logic';
import { ProductService } from '../../services/product.service';
import { getCustomFieldSchemas, initializeCustomFields, makeTableCustomFields } from '../../utils/CustomFieldEntities/custom-field-utils';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export const stats = writable(null);
export const customFieldsSchemas = writable([]);
export const tableCustomFields = writable([]);
export async function initList() {
    filter.set({ criteria: {}, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    await loadCustomFieldSchemas();
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    stats.set(null);
    await loadCustomFieldSchemas();
    if (oid == 0) {
        let tmpRecord = { oid: 0 };
        tmpRecord.customFields = initializeCustomFields(get(customFieldsSchemas));
        record.set(tmpRecord);
    }
    else {
        let _resp = await ProductService.fetchProduct(oid).toPromise();
        record.set(_resp.payload);
        await loadStats(oid);
    }
}
async function loadCustomFieldSchemas() {
    let schemas = await getCustomFieldSchemas("PRODUCTXXX");
    customFieldsSchemas.set(schemas);
    let tcf = await makeTableCustomFields(schemas, 'product');
    tableCustomFields.set(tcf);
}
async function loadStats(customerOid) {
    // let _resp = await ProductService.fetchProductStats(customerOid).toPromise();
    // stats.set(_resp.payload);
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await ProductService.getProducts(_filter, _pag.currentPage).toPromise();
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    navigate(`/product/0`);
}
export function onEdit(item) {
    navigate(`/product/${item.oid}`);
}
export async function save() {
    let _record = get(record);
    return ProductService.saveProduct(_record).toPromise();
}
export async function onDelete(item) {
    await ProductService.deleteProduct(item.oid).toPromise();
    await load();
}
export function onPageChange(pageNumber) {
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
